import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AdminShell } from "@/components/admin/admin-shell";
import { PlanForm, type PlanValues } from "@/components/admin/plan-form";

export const Route = createFileRoute("/admin/plans/$id/edit")({
  head: () => ({
    meta: [
      { title: "Edit Plan — Spayzo Admin" },
      { name: "description", content: "Modify plan details, pricing, features, and visibility." },
    ],
  }),
  component: Page,
});

const PRESET: PlanValues = {
  name: "Pro",
  tier: "Paid Subscription",
  description:
    "For growing merchants who want full control, advanced analytics, and premium visibility on Spayzo.",
  iconKey: "rocket",
  cycle: "monthly",
  monthlyPrice: "149",
  annualPrice: "1430",
  trialDays: "14",
  maxSpaces: "15",
  features: [
    { text: "Up to 15 active spaces", enabled: true },
    { text: "Advanced booking management", enabled: true },
    { text: "Full revenue & analytics suite", enabled: true, tag: "New" },
    { text: "Priority placement in search", enabled: true },
    { text: "Custom menu & add-ons", enabled: true },
    { text: "Email & live chat support", enabled: true },
    { text: "Dedicated account manager", enabled: false },
    { text: "White-label options", enabled: false },
  ],
  active: true,
  featured: true,
  showAnnualSavings: true,
  trialEnabled: true,
  allowDowngrade: false,
};

function Page() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  return (
    <AdminShell title={t("adminPlanForm.editPlan")} subtitle={t("adminPlanForm.editPlanSubtitle")}>
      <PlanForm
        mode="edit"
        planId={id}
        initial={PRESET}
        audit={{
          created: "Jan 10, 2025",
          edited: "Jun 02, 2025",
          editedBy: "Omar Al Rashid",
          subscribers: 698,
        }}
      />
    </AdminShell>
  );
}
